import { FieldsContext } from '@/contexts/FieldsContext'
import { useSheetTheme } from '@/contexts/SheetThemeContext'
import { useTranslation } from '@/hooks/useTranslation'
import { Button, cn } from '@flatfile/baseline'
import { useContext, useState } from 'react'
import { DisplayManagementPanel } from './DisplayManagementPanel'
import { DisplayManagementProps, ViewType } from './types'

export const DisplayManagement = ({
  disabled,
  sheetId,
}: Omit<DisplayManagementProps, 'density' | 'updateDensity'>) => {
  const [open, setOpen] = useState(false)
  const [viewType, setViewType] = useState<ViewType>('table')
  const { t } = useTranslation()
  const { density, updateDensity } = useSheetTheme()
  const {
    allColumnsHidden,
    columnsState,
    columnConfig,
    hiddenColumnsCount,
    setColumnsState,
    unhideColumns,
  } = useContext(FieldsContext)

  const buttonHeight = {
    compact: 'h-[26px]',
    default: 'h-[31px]',
    comfortable: 'h-[36px]',
  }[density]

  return (
    <DisplayManagementPanel
      sheetId={sheetId}
      columns={columnsState}
      columnConfig={columnConfig}
      setColumns={setColumnsState}
      open={open}
      onOpenChange={setOpen}
      viewType={viewType}
      onViewTypeChange={setViewType}
      density={density}
      updateDensity={updateDensity}
    >
      <Button
        size='icon-md'
        icon='settings-slider-three'
        aria-label='manage columns'
        variant='outline'
        className={cn(
          'border border-black bg-white hover:bg-white hover:border-black aspect-square rounded-none pr-8 pl-4 !important',
          buttonHeight
        )}
        data-testid='column-management-trigger'
        data-tooltip-id={'display-management'}
        data-tooltip-content={t('sheet.columnManagement.tooltip', {
          count: hiddenColumnsCount,
        })}
        disabled={disabled}
      />
    </DisplayManagementPanel>
  )
}
